export default __webpack_public_path__ + "static/media/analytics.dd05b8ed.svg";